import { combineReducers } from 'redux';
import volume from './volume/volumeReducer';

export default combineReducers({
	volume,
});
